module.exports = __webpack_public_path__ + "img/pr-10.07d0c388.png";